// Widget base: tarjeta KPI. Reutilizable por cualquier cliente.
// Recibe `block` (descripción de la config) + `data` (KPIs del backend) + `theme`.
import React from 'react';
import { formatValue, signColor } from '../format';

function singleKpi(item, data, theme, widgetData) {
  // Si el widget tiene su data_sql materializada (Fase 4), el valor sale de la
  // primera fila; si no, del payload compartido (data.kpis).
  const rows = widgetData?.rows;
  const value = rows && rows.length ? rows[0]?.[item.metric] : data?.kpis?.[item.metric];
  const color = item.colorBySign
    ? signColor(value, theme)
    : (item.tone === 'negative' ? theme.negative
      : item.tone === 'positive' ? theme.positive
      : theme.primary);
  return (
    <div className="vz-kpi-inner" key={item.metric}>
      <div className="vz-kpi-label">{item.label}</div>
      {item.sublabel && <div className="vz-kpi-sublabel">{item.sublabel}</div>}
      <div className="vz-kpi-value" style={{ color }}>
        {formatValue(value, item.format)}
      </div>
    </div>
  );
}

export default function KpiCard({ block, data, theme }) {
  const emphasis = block.emphasis ? ' vz-kpi--emphasis' : '';
  return (
    <div className={`vz-kpi${emphasis}`} style={{ borderTopColor: theme.accent }}>
      {singleKpi(block, data, theme, block._widgetData)}
    </div>
  );
}

// Variante: dos KPIs apilados en una sola tarjeta (réplica de las tarjetas dobles).
export function KpiPair({ block, data, theme }) {
  return (
    <div className="vz-kpi vz-kpi--pair">
      {block.items.map((item) => singleKpi(item, data, theme, block._widgetData))}
    </div>
  );
}
